import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HelperResourcesPanel = () => {
  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-6">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Lightbulb" size={24} className="text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-semibold text-foreground mb-2">Helper Resources</h3>
          <p className="text-sm text-muted-foreground mb-4">
            Access training materials, best practices, and support resources to enhance your helping skills and maintain your own wellbeing.
          </p>
          <div className="flex flex-wrap gap-3">
            <Button variant="outline" size="sm" iconName="BookOpen" iconPosition="left">
              Training Library
            </Button>
            <Button variant="outline" size="sm" iconName="Users" iconPosition="left">
              Helper Community
            </Button>
            <Button variant="outline" size="sm" iconName="Heart" iconPosition="left">
              Self-Care Guide
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelperResourcesPanel;